import { IconButton, InputAdornment, TextField } from '@mui/material';
import { Search, X } from 'lucide-react';
import React from 'react';
import type { IDashboardSearchBarProps } from '../interfaces';

export const DashboardSearchBar = ({
  value,
  placeholder = 'Search...',
  onChange,
  onClear,
}: IDashboardSearchBarProps) => {
  return (
    <TextField
      size="small"
      value={value}
      placeholder={placeholder}
      onChange={(event) => onChange(event.target.value)}
      sx={{
        width: { xs: '100%', sm: 300, md: 340 },
        '& .MuiOutlinedInput-root': {
          borderRadius: 3,
          backgroundColor: '#ffffff',
          fontSize: '0.84rem',
        },
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start" sx={{ color: '#71717a' }}>
            <Search size={16} />
          </InputAdornment>
        ),
        endAdornment: value ? (
          <InputAdornment position="end">
            <IconButton size="small" onClick={onClear} aria-label="Clear search" edge="end">
              <X size={14} />
            </IconButton>
          </InputAdornment>
        ) : undefined,
      }}
    />
  );
};
